<div class="row">
  <div class="col-md-12">
    <h4>Cambios de estado</h4>
    <div>
      <generic-table-avla
        #tablastatus
        [jsonData]="statusData"
        [columns]="statuscolumnas"
        [primaryIndexer]="primaryIndexerTable1"
        [serverPagination]="false"
        [enableGeneralSearch]="false"
        [editableRow]="false"
        [deletableRow]="false"
        [showReloadButton]="false"
        [showSelectorRowsOnPage]="false"
        [rowsOnPage]="5"
        [sortOrder]="'desc'"
        [textTableEmpty]="'No posee estados asociados'"
        [templateColumns]="{
          estado: estadoTemplate
        }"
        [textTableLoading]="'Cargando...'">
      </generic-table-avla>
    </div>
  </div>
</div>
<ng-template
  #estadoTemplate
  let-item="item"
  let-col="col"
  let-cellValue="cellValue">
  {{ getstatus(cellValue) }}
</ng-template>
